<template>
  <v-sheet color="grey700" class="py-6 px-8 rounded-0">
    <div class="text-uppercase mb-3">
      <h4 class="text-body-2 blue500--text font-weight-bold" v-text="$t('common.how_to_play')" />
      <h2 class="text-h5 font-weight-extrabold lh-1" v-text="$t('common.games.wheel')" />
    </div>

    <p class="body-text-2 text--secondary" v-text="$t('page.wheel.help.subtitle')" />

    <v-row align="center" class="mb-3">
      <v-col cols="12" sm="5">
        <v-img max-width="240" class="mx-auto" src="@/assets/img/games/wheel/help/1.jpg" />
      </v-col>
      <v-col cols="12" sm="7">
        <h4 class="text-subtitle-1 font-weight-bold blue400--text" v-text="$t('page.wheel.help.slide1.title')" />

        <!-- eslint-disable-next-line vue/no-v-html -->
        <p class="mb-0 text-body-2 text--secondary" data-md v-html="$mdt('page.wheel.help.slide1.text')" />

        <a
          class="link d-inline-block text-caption green500--text"
          @click="$modal.open('wheel-stacks', {maxWidth: 500})"
          v-text="$t('page.wheel.help.slide1.complicated')"
        />
      </v-col>
    </v-row>

    <v-row align="center" class="mb-3">
      <v-col cols="12" sm="7" order="2" order-sm="1">
        <h4 class="text-subtitle-1 font-weight-bold blue400--text" v-text="$t('page.wheel.help.slide2.title')" />
        <p class="mb-0 text-body-2 text--secondary" v-text="$t('page.wheel.help.slide2.text')" />
      </v-col>
      <v-col cols="12" sm="5" order="1" order-sm="2">
        <v-img max-width="240" class="mx-auto" src="@/assets/img/games/wheel/help/2.jpg" />
      </v-col>
    </v-row>

    <v-btn
      large block depressed
      color="green800"
      class="green500--text rounded-0 font-weight-semibold"
      :ripple="false"
      @click="close()"
      v-text="$t('page.wheel.help.dismiss')"
    />
  </v-sheet>
</template>

<script>
export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  methods: {},
}
</script>
